// extracted by mini-css-extract-plugin
export var rateTable = "_4s-0";